/* eslint-disable quotes */
class Tabs {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role="tab"]'));
    this.tabpanels = [];

    for (let i = 0; i < this.tabs.length; i++) {
      const tab = this.tabs[i];
      const tabpanel = document.querySelector(
        "#" + tab.getAttribute("aria-controls")
      );

      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", false);
      

      this.tabpanels.push(tabpanel);

      tab.addEventListener("keydown", this.onKeyDown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }

      this.lastTab = tab;
    }

    console.log("Start Tabs");
    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      setFocus = true;
    }

    for (let i = 0; i < this.tabs.length; i++) {
      const tab = this.tabs[i];

      if (currentTab === tab) {
        tab.setAttribute("aria-selected", true);
        tab.removeAttribute("tabindex");
        this.tabpanels[i].classList.remove("is-hidden");
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute("aria-selected", false);
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add("is-hidden");
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeyDown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case "ArrowRight":
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

(function() {
  function prepend($parent, $node) {
    $parent.insertBefore($node, $parent.children[0]);
  }

  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  }

  function buildButtons({ controls, id, label, selected }) {
    const $btn = document.createElement("button");
    $btn.textContent = label;
    $btn.type = "button";
    $btn.setAttribute("role", "tab");
    $btn.id = id;
    $btn.setAttribute("aria-selected", selected);
    $btn.setAttribute("aria-controls", controls);

    return $btn;
  }

  function buildTab({ content, id }) {
    const $tab = document.createElement("div");
    $tab.id = id;
    $tab.innerHTML = content;
    $tab.setAttribute("tabindex", 0);
    $tab.setAttribute("role", "tabpanel");

    return $tab;
  }

  function buildTabList(buttons) {
    const $tabList = document.createElement("div");
    $tabList.classList.add("tablist-wrapper");
    $tabList.setAttribute("role", "tablist");

    buttons.forEach(($btn) => $tabList.appendChild($btn));

    return $tabList;
  }

  function header() {
    const $h1 = document.createElement("h1");
    $h1.textContent = "FAQ";

    return $h1;
  }

  function start() {
    const $wrapper = document.querySelector("#faq-wrapper");
    const $sections = document.querySelectorAll("[data-faq-group]");
    const buttons = [];
    const tabs = [];

    const establishedTabs = {};

    console.log("all sections:", $sections, {
      groups: [...$sections].map(({ dataset }) => dataset.faqGroup),
    });

    $sections.forEach(($section, id) => {
      const { faqGroup, faqSubCategory } = $section.dataset;

      if (establishedTabs[faqGroup]) {
        const tabIndex = tabs.findIndex(
          ($div) => $div.id === establishedTabs[faqGroup]
        );

        tabs[tabIndex].innerHTML += $section.innerHTML;

      } else {
        buttons.push(
          buildButtons({
            id: `tabBtn-${id}`,
            controls: `tabPanel-${id}`,
            selected: id === 0,
            label: faqGroup,
          })
        );

        tabs.push(
          buildTab({
            id: `tabPanel-${id}`,
            content: $section.innerHTML,
          })
        );
        establishedTabs[faqGroup] = `tabPanel-${id}`;
      }
    });

    $wrapper.classList.add("tabs");
    prepend($wrapper, buildTabList(buttons));
    tabs.forEach(($tab) =>
      insertAfter($tab, $wrapper.querySelector(".tablist-wrapper"))
    );
    prepend($wrapper, header());

    document
      .querySelectorAll('[role="tablist"]')
      .forEach(($tab) => new Tabs($tab));
  }

  start();
})();
